<script setup lang="ts">
import type { AppLite } from '~/types'

interface Props {
  list: AppLite[] | undefined
}

defineProps<Props>()

const { toAppDetail } = useRouterToPage()
</script>

<template>
  <div>
    <div class="mx-auto w-fit flex" mb="28px md:60px">
      <Icon class="v-sub text-26px c-yellow-5 lt-md:hidden" name="Lightning" />
      <h2 class="select-none c-#ffffffe5 font-800" mx="20px md:14px" text="center 18px md:32px" lh="28px md:32px">
        {{ $t('home_page.hotapp_title') }}
      </h2>
      <Icon class="v-sub text-26px c-yellow-5 lt-md:hidden" name="Lightning" />
    </div>

    <div v-if="list?.length" class="relative my--20px of-hidden py-20px">
      <LdInfiniteLoop w="1680px md:2800px" :list="list.slice(0, list.length / 2)" direction="horizontal" animation-time="15000ms">
        <template #default="{ item }">
          <NuxtLink v-track="{ id: 'web-index-recommend-game', click: { value: { type: '热门游戏', name: item.appName, seo: item.seo, pkg: item.packageName } } }" :to="toAppDetail({ seo: item.seo, type: item.category }, { hasReturnUrl: true })" :aria-label="item.appName">
            <div class="group relative of-hidden transition-all-300" mr="16px md:40px" md:hover="scale-110">
              <LdImage class="aspect-ratio-1 rd-10px transition-all-300" w="68px md:100px" b="4px solid transparent" md:group-hover=" b-purple-5" :src="scaleImage(item.icon, 128)" :alt="item.appName" loading="lazy" />
              <div class="absolute bottom-0 left-0 h-50% w-full translate-y-8px rd-b-8px bg-gradient-to-t op-0 transition-all-300" from="purple-5 op-80" to="transparent" md:group-hover="op-80 translate-y--2px" />
            </div>
          </NuxtLink>
        </template>
      </LdInfiniteLoop>
      <LdInfiniteLoop w="1680px md:2800px" px="42px md:70px" mt="16px md:40px" :list="list.slice(list.length / 2)" direction="horizontal" animation-time="15000ms">
        <template #default="{ item }">
          <NuxtLink v-track="{ id: 'web-index-recommend-game', click: { value: { type: '热门游戏', name: item.appName, seo: item.seo, pkg: item.packageName } } }" :to="toAppDetail({ seo: item.seo, type: item.category }, { hasReturnUrl: true })" :aria-label="item.appName">
            <div class="group relative of-hidden transition-all-300" mr="16px md:40px" md:hover="scale-110">
              <LdImage class="aspect-ratio-1 rd-10px transition-all-300" w="68px md:100px" b="4px solid transparent" md:group-hover=" b-purple-5" :src="scaleImage(item.icon, 128)" :alt="item.appName" loading="lazy" />
              <div class="absolute bottom-0 left-0 h-50% w-full translate-y-8px rd-b-8px bg-gradient-to-t op-0 transition-all-300" from="purple-5 op-80" to="transparent" md:group-hover="op-80 translate-y--2px" />
            </div>
          </NuxtLink>
        </template>
      </LdInfiniteLoop>

      <div class="absolute left-0 top--5% h-110% w-40px from-[var(--bg-color)] to-transparent bg-gradient-to-r" />
      <div class="absolute right-0 top--5% h-110% w-40px rotate-180 from-[var(--bg-color)] to-transparent bg-gradient-to-r" />
    </div>
  </div>
</template>

<style lang="scss" scoped>
</style>
